export enum NavigationState {
  notFinishedError = 'not_finished_error',
  notStartedError = 'not_started_error',
  finished = 'finished',
  notFinished = 'not_finished',
}
